import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { checkIsPlatform, getTestId, Collapsible, Button } from '@airtel/air-design-system';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { CarouselWidgetComponent as CarouselWidget } from '../../components/carousel-widget/CarouselWidget';
import { getBankPartnerCardWidgetStyles } from './BankPartnerCardWidgetStyles';
import { PartnerCard } from './PartnerCard';
var bankPartnerCardWidgetStyles = getBankPartnerCardWidgetStyles();
var isWeb = checkIsPlatform('web');
export var BankPartnerCardWidgetComponent = props => {
  var _a;
  var style = props.style,
    listData = props.listData,
    _props$showIndicator = props.showIndicator,
    showIndicator = _props$showIndicator === void 0 ? false : _props$showIndicator,
    carouselWidgetProps = props.carouselWidgetProps,
    onUserAction = props.onUserAction,
    _props$isCollapsible = props.isCollapsible,
    isCollapsible = _props$isCollapsible === void 0 ? false : _props$isCollapsible,
    initialCount = props.initialCount,
    collapsedCtaText = props.collapsedCtaText,
    expandedCtaText = props.expandedCtaText,
    _props$collapsedCtaIc = props.collapsedCtaIcon,
    collapsedCtaIcon = _props$collapsedCtaIc === void 0 ? 'DownChevronIcon' : _props$collapsedCtaIc,
    _props$expandedCtaIco = props.expandedCtaIcon,
    expandedCtaIcon = _props$expandedCtaIco === void 0 ? 'UpChevronIcon' : _props$expandedCtaIco,
    onTogglePressMetaData = props.onTogglePressMetaData,
    isGridLayout = props.isGridLayout,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'BankPartnerCardWidgetComponent' : _props$testID;
  var _useState = useState(false),
    isCollapsibleOpen = _useState[0],
    setIsCollapsibleOpen = _useState[1];
  var _useState2 = useState(listData),
    collapsedListData = _useState2[0],
    setCollapsetListData = _useState2[1];
  useEffect(() => {
    if (isCollapsible) {
      setCollapsedListDataFunc();
    }
  }, [isCollapsibleOpen]);
  var onTogglePress = () => {
    onTogglePressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, onTogglePressMetaData), props));
    setIsCollapsibleOpen(!isCollapsibleOpen);
  };
  var setCollapsedListDataFunc = () => {
    if ((listData === null || listData === void 0 ? void 0 : listData.length) > initialCount && initialCount) {
      var updatedInitialCount = isCollapsibleOpen ? listData === null || listData === void 0 ? void 0 : listData.length : initialCount;
      var _collapsedListData = (listData === null || listData === void 0 ? void 0 : listData.length) && (listData === null || listData === void 0 ? void 0 : listData.slice(0, updatedInitialCount));
      setCollapsetListData(_collapsedListData);
    }
  };
  var partnerCardList = (_a = listData === null || listData === void 0 ? void 0 : listData.map((data, id) => _jsx(PartnerCard, Object.assign({}, data, {
    onUserAction: onUserAction
  }), 'partnerCard_' + id))) !== null && _a !== void 0 ? _a : [];
  return _jsxs(_Fragment, {
    children: [!isGridLayout && !!(listData === null || listData === void 0 ? void 0 : listData.length) && _jsx(View, Object.assign({
      style: style
    }, {
      children: _jsx(CarouselWidget, Object.assign({
        data: partnerCardList,
        showIndicators: showIndicator,
        indicatorBottomPosition: isWeb ? -12 : 0,
        carouselType: "COMPONENT",
        theme: "light",
        showNavigationCounter: false,
        alignment: "center"
      }, carouselWidgetProps, getTestId(testID, 'carousel')))
    })), !!isGridLayout && _jsxs(_Fragment, {
      children: [_jsx(Collapsible, Object.assign({
        showIcon: false,
        version: "variable-width",
        childPaddingToken: "SPACING_0",
        titlePaddingToken: "SPACING_0",
        initialOpen: true
      }, getTestId(testID + '_Collapsible'), {
        children: _jsx(View, Object.assign({
          style: bankPartnerCardWidgetStyles.containerCard
        }, {
          children: collapsedListData === null || collapsedListData === void 0 ? void 0 : collapsedListData.map((data, id) => _jsx(View, Object.assign({
            style: bankPartnerCardWidgetStyles.partnerCardWidth
          }, {
            children: _jsx(PartnerCard, Object.assign({}, data, {
              onUserAction: onUserAction
            }), 'partnerCard_' + id)
          }), id))
        }))
      })), !!isCollapsible && _jsx(Button, Object.assign({
        iconName: isCollapsibleOpen ? expandedCtaIcon : collapsedCtaIcon,
        iconPosition: "right",
        buttonType: "tertiary",
        version: "fixed-padding",
        title: isCollapsibleOpen ? expandedCtaText : collapsedCtaText,
        style: bankPartnerCardWidgetStyles.ctaStyles,
        onPress: onTogglePress
      }, isCollapsibleOpen ? props === null || props === void 0 ? void 0 : props.expandedCtaAccessibilityProps : props === null || props === void 0 ? void 0 : props.collapsedCtaAccessibilityProps, getTestId(testID, 'viewAllCta')))]
    })]
  });
};
BankPartnerCardWidgetComponent.genericRendererKey = 'AirBankPartnerCardWidget';